// Angular imports
import { Component, OnInit, Input, Injector } from '@angular/core';

// Component imports
import { MPSearchBaseComponent } from '../_base/mp-base-search.component';

// Service imports
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { SearchService } from '../_services/data-services/search.service';

// Model imports
import { SearchParametersDto } from '../_models/search-parameters-dto';
import { OwnerSearchResultDto } from '../_models/owner-search-result-dto';

@Component({
    selector: 'app-search-properties-all-owners',
    templateUrl: './search-properties-all-owners.component.html',
    styleUrls: ['./search-properties-all-owners.component.scss']
})
export class SearchPropertiesAllOwnersComponent extends MPSearchBaseComponent implements OnInit {
    @Input() communityId: number;

    propertyAllOwners: OwnerSearchResultDto[] = [];

    constructor(
        protected readonly injector: Injector,
        private readonly errorService: ServerErrorService,
        private readonly searchService: SearchService
    ) {
        super(injector);
    }

    ngOnInit() {
        if (!!this.searchText) {
            this.searchAllOwners();
        }
    }

    onOpenBalanceClick(data: OwnerSearchResultDto) {
        this.setPropertyContext(data.communityId, data.accountNumber, 'statement', 'view=open-balance');
    }

    onStatementClick(data: OwnerSearchResultDto) {
        this.setPropertyContext(data.communityId, data.accountNumber, 'statement', 'view=statement');
    }

    searchAllOwners() {
        const param: SearchParametersDto = new SearchParametersDto();
        param.clearCache = true;
        param.searchText = this.searchText;
        param.communityId = this.communityId;

        this.propertyAllOwners = [];
        this.loadingVisible = true;
        this.searchService.searchAllOwners(param).subscribe(
            (data: OwnerSearchResultDto[]) => {
                this.propertyAllOwners = data;
                this.updateGridSearchStatus(data);
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
